import { useState } from 'react';
import DeviceList from '../features/DeviceList/index.web';

const DeviceListWidget = ({
  setShowCurrentDevice,
  setShowDeviceSettings,
  selectedGroup,
  setSelectedGroup,
}) => {
  // The widget owns the query window that the page keeps in ConnectedDevices.jsx.
  // Nothing above a dashboard widget can hold it — widgetHelpers renders this with no
  // range props — so before this the Time Period Search wrote into noop setters and the
  // datasheets it opens kept reading their default last 24 hours. FE-02/FE-03: the
  // control only SETS the range and each consumer fetches on the range it is given, so
  // the widget has to be that owner for its Search to mean anything.
  //
  // Seeded once at mount, like DeviceGraphWidget: a fresh Date.now() on every render
  // (every socket event re-renders this) would re-key every consumer's fetch.
  const [startTime, setStartTime] = useState(() => Date.now() - 24 * 60 * 60 * 1000);
  const [endTime, setEndTime] = useState(() => Date.now());

  return (
    <div className="h-100 w-100">
      <DeviceList
        setShowCurrentDevice={setShowCurrentDevice}
        setShowDeviceSettings={setShowDeviceSettings}
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
        startTime={startTime}
        endTime={endTime}
        setStartTime={setStartTime}
        setEndTime={setEndTime}
        widget
      />
    </div>
  );
};

export default DeviceListWidget;
